module.exports = __webpack_public_path__ + "static/img/mid.64c8b7e5.gif";